import { Badge } from '@/components/ui/badge';
import { PackageIcon } from '@phosphor-icons/react';

export function ProductV2PillV2({ name }: { name: string }) {
  return (
    <Badge variant="outline" className="cursor-pointer flex gap-1 items-center">
      <PackageIcon className="size-4" />
      {name}
    </Badge>
  );
}
